/**
 * useTooltipDismissed — Track one-time tooltip dismissals via localStorage.
 *
 * Each tooltip has a unique id. Once dismissed, it won't show again for that
 * browser. Returns [isDismissed, dismiss] — similar to useState pattern.
 *
 * Usage:
 *   const [dismissed, dismiss] = useTooltipDismissed('voting-regenerate');
 *   if (!dismissed) { show tooltip... onClick={dismiss} }
 */
import { useState, useCallback } from 'react';

const STORAGE_PREFIX = 'tabletryb_tooltip_';

export function useTooltipDismissed(id: string): [boolean, () => void] {
  const key = `${STORAGE_PREFIX}${id}`;

  const [dismissed, setDismissed] = useState<boolean>(() => {
    try {
      return localStorage.getItem(key) === '1';
    } catch {
      return false;
    }
  });

  const dismiss = useCallback(() => {
    try {
      localStorage.setItem(key, '1');
    } catch {
      // localStorage unavailable — dismiss for this session only
    }
    setDismissed(true);
  }, [key]);

  return [dismissed, dismiss];
}
